import React, { useEffect, useState, useRef, useCallback } from 'react';
import style from './log.module.sass';
import { Select, Checkbox } from 'antd';
import { Client } from 'paho-mqtt'
import { logger } from "../../../constant/winston";

const { Option } = Select;

interface IProps {
    appList: any[],
}

const Logs: React.FC<IProps> = (props) => {

    const mqClient = useRef<any>(null);
    const scrollContainer = useRef<any>(null);
    const [logList, setLogList] = useState<any[]>([])
    const [selectedApp, setSelectedApp] = useState<string>('')
    const [isClientConnected, setClientConnected] = useState<boolean>(false)
    const [autoScroll, setAutoScroll] = useState<boolean>(true)
    const [clearFlag, setClearFlag] = useState<boolean>(false)

    const onConnectionLost = (responseObject: any) => {
        if (responseObject.errorCode !== 0) {
        }
    }

    const onMessageArrived = useCallback((message: any) => {
        if(JSON.parse(message.payloadString))
        setLogList((state) => [...state, JSON.parse(message.payloadString)])
    },[])

    // called when the client connects
    const onConnect = () => {
        setClientConnected(true)
        logger.debug("MQTT Connected!!!");
    }

    useEffect(() => {
        if(!mqClient.current){
            const clientId = 'studio_web_' + Math.random().toString(16).substr(2, 8)
            // Create a client instance
            const client = new Client('wss://dev-flow.autonom8.com/mqtt',clientId);
            // set callback handlers
            client.onConnectionLost = onConnectionLost;
            client.onMessageArrived = onMessageArrived;
            
            // connect the client
            client.connect({
                onSuccess:onConnect,
                onFailure: function (data: any) {
                    logger.error('MQTT Connection Failed!')
                },
                userName: 'a8flowUser-dev',
                password: 'a8Passw0rd!'
            });
            
            mqClient.current = client;
        } else {
            mqClient.current.onMessageArrived = onMessageArrived;
        }
    }, [onMessageArrived])

    useEffect(() => {
        if(selectedApp) {
            setLogList([])
        }

        if(mqClient && selectedApp && isClientConnected) {
            mqClient.current.subscribe(`orgs-dev/logs/${selectedApp}`)
        }
        return () => {
            if(mqClient && selectedApp && isClientConnected) {
                mqClient.current.unsubscribe(`orgs-dev/logs/${selectedApp}`)
            }
        }
    }, [selectedApp, isClientConnected])

    const handleSearch = (input: string, option: any) => {
        if(!option.props.children) {
            return false                                
        } else {
            return option.props.children.toLowerCase().includes(input.toLowerCase())
        }
    }

    useEffect(() => {
        if(scrollContainer && scrollContainer.current && autoScroll) {
            // This will scroll to the bottom
            scrollContainer.current.scrollIntoView(false)
        }
    }, [logList.length, autoScroll])

    return (
        <div className={style.main}>
            <div className={style.header}>
                <Select showSearch onChange={(value: string) => setSelectedApp(value)} filterOption={handleSearch} data-test-id="select_logs" defaultValue="Apps" className={style.select} style={{ width: 240 }}>
                    {
                        props.appList.map((item, index) => <Option key={item.appId} data-test-id={`logs_services${index}`} value={item.appId}>{item.appName}</Option>)
                    }
                </Select>
                <div style={{display: 'flex'}}>
                    <Checkbox defaultChecked={autoScroll} onChange={(e) => setAutoScroll(e.target.checked)} style={{color: 'white', display:'flex', alignItems: 'center'}}>
                        Auto Scroll
                    </Checkbox>
                    <div className={style.button} onClick={() => {
                        setClearFlag(true)
                        setLogList([])
                    }}>
                        Clear
                    </div>
                </div>
            </div>
            <div className={style.body}>
                {
                    (!selectedApp) ? <div style={{margin: '24px 30px', fontFamily: 'system-ui'}}>Please select an app to stream its logs</div> :
                    (selectedApp && !isClientConnected) ? <div style={{margin: '24px 30px', fontFamily: 'system-ui'}}>Loading...</div> : 
                    (selectedApp && isClientConnected && logList.length === 0 && !clearFlag) ? <div style={{margin: '24px 30px', fontFamily: 'system-ui'}}>Waiting for logs...</div> : null
                }
                <ul ref={scrollContainer} style={{display: 'flex', flexDirection: 'column', gap: '6px'}}>
                    {
                        logList.map((item, index) => {
                            let labels = ''
                            item.entry.labels && Object.entries(item.entry.labels).forEach(([key,value]) => {
                                if(typeof value === 'object') {
                                    labels += ` ${key}=${JSON.stringify(value)}`
                                } else {
                                    labels += ` ${key}=${value}`
                                }
                            }) 
                            if(typeof item.entry.textPayload === 'object') {
                                item.entry.textPayload = JSON.stringify(item.entry.textPayload)
                            }
                            return (
                                <li key={index} style={{fontFamily: 'monospace'}}>
                                    <span className={`${style.pill} ${style[item.entry.severity]}`}>{item.entry.severity.toUpperCase()}</span>
                                    <span style={{color: '#a79ff5'}}>{item.entry.timestamp}</span>
                                    <span style={{color: '#7debcc'}}>[{item.appVer}]</span>
                                    <span style={{color: '#EEECF1'}}> : </span>
                                    <span style={{color: '#EEECF1'}}>{item.entry.textPayload}</span>
                                    <span style={{color: '#9F9F9F'}}>{labels}</span>
                                </li>
                            )
                        })
                    }
                </ul>
            </div>
        </div >
    )
}


export default Logs;